export const ENDPOINTS = {
  getUserBookings: '/gateway/admin/users/:id/bookings',
} as const;

export const CORE_QUERY_KEYS = {
  user: 'admin-user',
} as const;
